var ServerApiKeyAuthProvider = function () {
  function ServerApiKeyAuthProvider() {}

  ServerApiKeyAuthProvider.TYPE = "api-key";
  ServerApiKeyAuthProvider.DEFAULT_NAME = "api-key";
  return ServerApiKeyAuthProvider;
}();

export default ServerApiKeyAuthProvider;